import {useState} from 'react';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { addComma, HOSTNAME, isExternalUrl,getImageUrlWithMaxWidth } from '@src/utils';
import toast from "@src/utils/toast";
import './productHallCard.scss'
import { addLikeSlot } from '@src/api/weddingHall/weddingHall';
interface IHallInfo {
    weddingDayId?: number;
    id?: number; //weddingDayId와 동일한 값
    uuid?: string;
    name: string;
    partnerId?: number;
    partnerUuid?: string;
    image: {title:string;url: string} | null;
    weddingDate: string;
    weddingTime: string;
    dayOfWeek?: string; //사용은 X
    guarantee: number;
    finalAmount: number;
    slotFinalPrice?: number;
    discountRate: number;
    isLiked?: boolean | number;
}

type Props = {
    hallInfo?: IHallInfo;
    partnerId?:string | number;
    isLike?: 0 | 1 | boolean;
    hasLike?:boolean;
}

/**
 *
 * 상품(슬롯) 카드
 * @param hallInfo 웨딩홀 기본 정보
 * @param partnerId  파트너 아이디
 * @param isLike 사용자가 좋아요/찜 등록했는지 여부(옵셔널)
 * @param hasLike 하트 아이콘 사용 여부(옵셔널)
 */

const ProductHallCard = ({hallInfo, partnerId, isLike, hasLike=true}:Props) => {
    const params = useParams();
    const partnerUuid = hallInfo.partnerUuid || params.uuid;

    const [isFullHeart, setIsFullHeart] = useState((isLike || isLike === 1) && hasLike);

    const clickHeartIcon = (e, slotId) => {
        e.stopPropagation();
        setIsFullHeart(!isFullHeart);
        const toastContainer = document.querySelector('.app-toast-container') as HTMLElement;
        if (toastContainer) {
            const originalZIndex = toastContainer.style.zIndex;
            toastContainer.style.zIndex = '200000';  // 원하는 z-index 값으로 변경
            setTimeout(() => {
                toastContainer.style.zIndex = originalZIndex;
            }, 5000);  // 5초 후 원래 값으로 복원
        }
       
        if (isFullHeart === false) {
            addLikeSlot(slotId).then(res => {
                if(res === 200){
                    toast.success("찜목록에 추가했습니다.", {
                        link: {
                            text: "찜 목록 보기",
                            url: isExternalUrl(`${HOSTNAME}/my-interest/like/slot`),
                        },
                    });
                }
            })
        } else {
            addLikeSlot(slotId).then(res => {
                if(res === 200){
                    toast.success("찜목록에서 삭제했습니다.", { isShowClose: true });
                }
            })
        }
    }

    const dateParse = dayjs(hallInfo.weddingDate?.replaceAll('.','-')).format('YYYY-MM-DD(ddd)'); // 사파리 지원 날짜 형태로 변환

    return (
        <div className={`product-card-wrap card-${hallInfo.weddingDayId || hallInfo.id}`} >
            <div className='product-wrap card-item' 
            onClick={()=>{
              window.location.href = isExternalUrl(`${HOSTNAME}/weddinghall/${partnerUuid}/slot?id=${hallInfo.weddingDayId || hallInfo.id}`)
            }}
            >
                <div className='thumb thumb-square-80'>
                    <img className='product-img' 
                        src={getImageUrlWithMaxWidth(hallInfo.image?.url)} 
                        alt=''
                        style={{ opacity: 0 }}
                        onLoad={(e) => {
                            const target = e.target as HTMLImageElement;
                            if (hallInfo?.image?.url) {
                              target.style.opacity = "1";
                            }
                          }}
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.style.opacity = "0";
                          }}
                          loading="lazy"
                        />
                </div>
        
                <div className='hall-info-wrap'>
                    <h2>{hallInfo.name}</h2>
                    <p className='bold'>
                       {hallInfo.discountRate > 0 && <span className='discount'>{hallInfo.discountRate}%</span>}
                        <span className='price'>{addComma(hallInfo.finalAmount)}원</span>
                    </p>
                    <p className={`time-contents bar`}>
                        <span>{dateParse.replaceAll('-','.')}</span>
                        <span>{hallInfo.weddingTime?.split(':')[0]+'시 '}{hallInfo.weddingTime?.split(':')[1] !== '00' && hallInfo.weddingTime?.split(':')[1]+'분'}</span>
                        <span>{hallInfo.guarantee}명</span>
                    </p>
                </div>
                {hasLike && 
                <i className={`icon ${isFullHeart ? 'icon-heart-filled': 'icon-heart-gray900'}`} onClick={(e)=>clickHeartIcon(e,hallInfo.weddingDayId || hallInfo.id)}/>} 
            </div>
        </div>
    );
};

export default ProductHallCard;